import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const SortIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg viewBox="0 0 17 17" width={size} {...props}>
    <path
      d="M4.886 2.046c.374 0 .682.308.682.68v11.342L8.09 11.23a.692.692 0 0 1 .954-.068.685.685 0 0 1 .069.95l-3.749 4.15a.633.633 0 0 1-.99 0L.66 12.112c-.239-.27-.203-.68.07-.95.271-.24.68-.203.953.068l2.522 2.838V2.727c0-.373.308-.68.682-.68Zm6.75-1.29c.285-.35.694-.331 1.022 0l3.683 4.148c.239.271.203.68-.07.955-.271.238-.68.202-.953-.07l-2.522-2.837V14.29c0 .376-.308.648-.682.648a.684.684 0 0 1-.682-.68V2.948L8.91 5.788c-.112.173-.535.402-.954.068a.688.688 0 0 1-.069-.951Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
SortIcon.propTypes = propTypes;

export default SortIcon;
